import { useEffect } from "react";
import { usePrevious } from "../../../core";
import { Select, SelectProps } from "../../inputs";
import { TableColumnDef } from "../types";

import styles from "./styles.module.scss";

export function SelectColumn<T extends object = {}, TValue = unknown>(
  { selectProps, ...params }: TableColumnDef<T> & {
    selectProps?: SelectProps<TValue>
  },
): TableColumnDef<T> {
  return {
    enableColumnFilter: true,
    minSize: 50,
    cell: ({ renderValue }) => <span className={styles.content}>{renderValue() as any}</span>,
    ...params,
    meta: {
      defaultFilterFn: "equals",
      additionalFilterFn: [ "equals", "arrIncludesSome" ],
      Filter: ({ label, value, onChange, autoFocus, filterFn }) => {
        const previousFilterFn = usePrevious(filterFn);
        const isMulti = filterFn.toString()
          .includes("arrIncludes");

        useEffect(() => {
          if (!!previousFilterFn && previousFilterFn !== filterFn) {
            if (isMulti) {
              onChange([ value ]);
            } else {
              onChange(Array.isArray(value) ? value?.[0] : null);
            }
          }
        }, [ filterFn, onChange, previousFilterFn, value, isMulti ]);

        return (
          <Select<TValue>
            autoFocus={autoFocus}
            label={label}
            value={value as any}
            onChange={onChange}
            isMulti={isMulti}
            {...selectProps}
          />
        );
      },
      ...params?.meta,
      excelProps: {
        valueModifier: selectProps?.getOptionLabel as any,
        filterButton: true,
        ...params?.meta?.excelProps,
      },
    },
  };
}
